import _toConsumableArray from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import auth from "./app/auth";
import product from "./app/product";
import account from "./app/account";
import process from "./app/process-purchase";
var routes = [{
  path: '/',
  component: function component() {
    return import('layouts/main-layout.vue');
  },
  children: [{
    path: '',
    name: 'home',
    component: function component() {
      return import('pages/Index.vue');
    }
  }, {
    path: 'terminos-y-condiciones',
    name: 'terms',
    component: function component() {
      return import('pages/Terms.vue');
    }
  }, {
    path: 'aviso-de-privacidad',
    name: 'privacity',
    component: function component() {
      return import('pages/Privacity.vue');
    }
  }].concat(_toConsumableArray(process), _toConsumableArray(auth), _toConsumableArray(product), _toConsumableArray(account))
}, {
  path: '*',
  component: function component() {
    return import('pages/error-404.vue');
  }
}];
export default routes;